export const API_URL = process.env.REACT_APP_SHREDXPRO_API_URL;
export const SUPPORT_EMAIL = "support@shredxpro.com";

// Set the real listing URLs at launch — store badges appear automatically once set.
export const STORE_LINKS = {
    apple: null,
    google: null,
};

export const BRAND = {
    logo: "/brand/logo-full.png",
    logoFooter: "/brand/logo-footer.png",
    wordmark: "/brand/wordmark.png",
    wordmarkNav: "/brand/wordmark-nav.png",
    icon: "/brand/icon.png",
};

export const PLANS = [
    {
        duration_months: 1,
        price: 999,
        currency: "INR",
        label: "1 Month",
        tagline: "Test the waters",
        is_featured: false,
        trial_days: 7,
    },
    {
        duration_months: 3,
        price: 2499,
        currency: "INR",
        label: "3 Months",
        tagline: "Build momentum",
        is_featured: true,
        trial_days: 7,
    },
    {
        duration_months: 6,
        price: 4499,
        currency: "INR",
        label: "6 Months",
        tagline: "Commit to the change",
        is_featured: false,
        trial_days: 7,
    },
    {
        duration_months: 12,
        price: 8499,
        currency: "INR",
        label: "12 Months",
        tagline: "Full-year transformation",
        is_featured: false,
        trial_days: 7,
    },
];

export const PLAN_FEATURES = [
    "Personalized workout plan",
    "Personalized nutrition plan",
    "AI Coach",
    "Smart exercise & food swaps",
    "Coach-guided & classic trackers",
    "Progress tracking, recipes & habits",
    "Progression & adaptation engine",
];

export const FEATURES = [
    { num: "01", key: "01-workout", name: "Personalized Workout", headline: "Your workout. Built for you.", desc: "Goal-based programming — today's exercises, sets, reps, rest and your weekly training schedule, all personalized." },
    { num: "02", key: "02-nutrition", name: "Personalized Nutrition", headline: "Your nutrition. Dialed in.", desc: "Personalized calories, protein and macros turned into real meals and portions for every day." },
    { num: "03", key: "03-ai-coach", name: "AI Coach", headline: "Your coach. Always with you.", desc: "Ask anything — training, nutrition, your plan, your progress — and get guidance in context." },
    { num: "04", key: "04-exercise-swap", name: "Smart Exercise Swaps", headline: "Can't do it? Swap it.", desc: "Intelligent substitutions matched to the exercise's purpose — never random alternatives." },
    { num: "05", key: "05-food-swap", name: "Smart Food Swaps", headline: "Don't like it? Swap it.", desc: "Nutrition-aware replacements that respect your preferences and dietary requirements." },
    { num: "06", key: "06-coach-guided", name: "Coach Guided Tracker", headline: "Just follow the plan.", desc: "Set-by-set guidance with reps, load, rest timers and instructions. Built for beginners." },
    { num: "07", key: "07-classic-tracker", name: "Classic Workout Tracker", headline: "Train your way.", desc: "Fast, efficient logging of sets, reps, weight and RPE for experienced lifters." },
    { num: "08", key: "08-progress", name: "Progress Tracking", headline: "See the work pay off.", desc: "Weight, measurements, workout history and nutrition adherence — trends that prove it's working." },
    { num: "09", key: "09-habits", name: "Habits, Steps & Water", headline: "The daily details matter.", desc: "Steps, water and daily habits with simple targets and satisfying completion." },
    { num: "10", key: "10-recipes", name: "Recipes", headline: "Eat better. Without eating boring.", desc: "A macro-friendly recipe library with categories, calories, protein, ingredients and instructions." },
    { num: "11", key: "11-custom-plan", name: "Custom Plan Builder", headline: "Your plan. Your rules.", desc: "Advanced: build custom days, exercises, sets, reps, rest and meals. Optional — your automated plan remains the default." },
    { num: "12", key: "12-adaptation", name: "Smart Adaptation", headline: "Your plan evolves with you.", desc: "SHREDxpro monitors performance and adherence, then adjusts your plan using its configured coaching methodology." },
    { num: "13", key: "13-learning-hub", name: "Learning Hub", headline: "Get fit. Get informed.", desc: "A premium built-in education library: training, nutrition, fat loss, muscle, habits and recovery." },
].map((f) => ({ ...f, src: `/screenshots/${f.key}.webp` }));
